import { render } from "./SaveEmployeeJobAssigns.vue?vue&type=template&id=449e8f86"
import script from "./SaveEmployeeJobAssigns.vue?vue&type=script&lang=js"
export * from "./SaveEmployeeJobAssigns.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__